export default "__VITE_PUBLIC_ASSET__b7a761cf__"